import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../redux/userSlice';
import eventReducer from '../redux/eventSlice';
import venueReducer from '../redux/venueSlice';
import locationReducer from '../redux/locationSlice';
import { apiMiddleware } from '../redux/middleware/apiMiddleware';
import contactReducer from '../redux/contactSlice';
import orderReducer from '../redux/orderSlice';
import ticketReducer from '../redux/ticketSlice';
import invitationReducer from '../redux/invitationSlice';

export const store = configureStore({
    reducer: {
        user: userReducer,
        event: eventReducer,
        venue: venueReducer,
        contact: contactReducer,
        location: locationReducer,
        order: orderReducer,
        ticket: ticketReducer,
        invitation: invitationReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(apiMiddleware),
});
